<script lang="ts">
  import SearchBar from "./components/SearchBar.svelte";
  import TrendingWorkflows from "./components/TrendingWorkflows.svelte";
  import ResultsPanel from "./components/ResultsPanel.svelte";
  import Header from "./components/Header.svelte";
  import { WORKFLOWS } from "./lib/commands";

  let searchQuery = $state("");
  let showResults = $state(false);
  let currentResult = $state<any>(null);

  function handleSearch(query: string) {
    searchQuery = query;
    if (query.trim()) {
      showResults = true;
      // Mock result for now
      currentResult = { type: "search", query };
    } else {
      showResults = false;
      currentResult = null;
    }
  }

  function handleWorkflowSelect(workflow: typeof WORKFLOWS[0]) {
    searchQuery = workflow.command;
    showResults = true;
    currentResult = { type: "workflow", workflow };
  }

  function handleClear() {
    searchQuery = "";
    showResults = false;
    currentResult = null;
  }
</script>

<div class="app">
  <Header />

  <main class="main">
    <div class="container">
      {#if !showResults}
        <div class="hero fade-in-up">
          <h1 class="title">Blockchain Explorer</h1>
        </div>
      {/if}

      <div class="search-section" class:compact={showResults}>
        <SearchBar
          value={searchQuery}
          onSearch={handleSearch}
          onClear={handleClear}
        />
      </div>

      {#if showResults && currentResult}
        <div class="results-section fade-in-up">
          <ResultsPanel result={currentResult} />
        </div>
      {:else}
        <div class="workflows-section fade-in-up" style="animation-delay: 100ms">
          <TrendingWorkflows
            workflows={WORKFLOWS}
            onSelect={handleWorkflowSelect}
          />
        </div>
      {/if}
    </div>
  </main>
</div>

<style>
  .app {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .main {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-top: 60px;
  }

  .container {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding: var(--space-6);
  }

  .hero {
    text-align: center;
    padding: var(--space-16) 0 var(--space-10);
  }

  .title {
    font-size: clamp(2.5rem, 6vw, 3.5rem);
    font-weight: 700;
    letter-spacing: -0.03em;
    margin-bottom: var(--space-4);
    background: linear-gradient(
      to bottom,
      var(--text-primary) 0%,
      var(--text-secondary) 100%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .subtitle {
    font-size: 1.125rem;
    color: var(--text-secondary);
    line-height: 1.6;
  }

  .search-section {
    margin-bottom: var(--space-8);
    transition: all var(--transition-slow);
  }

  .search-section.compact {
    position: sticky;
    top: 60px;
    z-index: 100;
    padding: var(--space-4) 0;
    margin: 0 calc(-1 * var(--space-6));
    padding-left: var(--space-6);
    padding-right: var(--space-6);
    background: linear-gradient(
      to bottom,
      var(--bg-primary) 0%,
      var(--bg-primary) 80%,
      transparent 100%
    );
  }

  .results-section {
    min-height: 400px;
  }

  .workflows-section {
    margin-top: var(--space-8);
  }
</style>
